<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Integrità
      <v-spacer />
      <v-switch
        hide-details
        label="Usa Contabili"
        class="mt-n2 mr-4"
        inset
        v-model="usa_contabili"
      >
      </v-switch>
      <v-switch
        hide-details
        label="Confronta"
        class="mt-n2"
        inset
        v-model="show_confronta"
      >
      </v-switch>
    </v-card-title>
    <v-card-subtitle class="mt-1">
      <v-row no-gutters>
        <v-col cols="4" class="pr-2">
          <v-select
            :items="periodi_list"
            v-model="intervallo"
            label="Periodo"
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col cols="4" class="pl-2">
          <v-select
            :items="analisi_list"
            v-model="analisi"
            label="Analisi per..."
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col cols="4" class="pl-2" v-if="show_confronta">
          <v-select
            label="Anno di Confronto"
            outlined
            dense
            :items="anni"
            v-model="anno_confronto"
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-progress-linear :active="loading" indeterminate color="primary" absolute />
    <v-card-text>
      <v-row align="center">
        <v-col cols="6">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left"></th>
                  <th class="text-left">{{ labelPeriodo }}</th>
                  <th class="text-left" v-if="show_confronta">Anno {{ anno_confronto }}</th>
                  <th class="text-left" v-if="show_confronta">Variazione %</th>
                  <th class="text-left" v-if="show_confronta">Delta €</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span class="green--text"><b>Verde</b></span>
                  </td>
                  <td>{{ formatEur(totali.verde) }}</td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto">{{ formatEur(totali_confronto.verde) }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.verde, totali_confronto.verde)">
                      {{ varPct(totali.verde, totali_confronto.verde) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.verde, totali_confronto.verde)">
                      {{ varDelta(totali.verde, totali_confronto.verde) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>
                    <span class="green--text">Non saldato verde</span>
                  </td>
                  <td>
                    {{ formatEur(totali.verde_non_saldato) }}
                    <span class="grey--text text-caption ml-1">({{ pctNonSaldato(totali.verde_non_saldato, totali.verde) }})</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto">{{ formatEur(totali_confronto.verde_non_saldato) }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta"></td>
                  <td v-if="show_confronta"></td>
                </tr>
                <tr>
                  <td>
                    <span class="blue--text"><b>Blu</b></span>
                  </td>
                  <td>{{ formatEur(totali.blu) }}</td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto">{{ formatEur(totali_confronto.blu) }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.blu, totali_confronto.blu)">
                      {{ varPct(totali.blu, totali_confronto.blu) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.blu, totali_confronto.blu)">
                      {{ varDelta(totali.blu, totali_confronto.blu) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                </tr>
                <tr class="grey lighten-4">
                  <td>
                    <span class="blue--text">Non saldato blu</span>
                  </td>
                  <td>
                    {{ formatEur(totali.blu_non_saldato) }}
                    <span class="grey--text text-caption ml-1">({{ pctNonSaldato(totali.blu_non_saldato, totali.blu) }})</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto">{{ formatEur(totali_confronto.blu_non_saldato) }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta"></td>
                  <td v-if="show_confronta"></td>
                </tr>
                <tr>
                  <td>
                    <span class="amber--text"><b>Totale</b></span>
                  </td>
                  <td>{{ formatEur(totali.combinato) }}</td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto">{{ formatEur(totali_confronto.combinato) }}</span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.combinato, totali_confronto.combinato)">
                      <b>{{ varPct(totali.combinato, totali_confronto.combinato) }}</b>
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="varClass(totali.combinato, totali_confronto.combinato)">
                      <b>{{ varDelta(totali.combinato, totali_confronto.combinato) }}</b>
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="purple--text"><b>Rapporto</b></span>
                  </td>
                  <td>
                    <span class="green--text">{{ ratioVerde(totali).toFixed(1) }} %</span>
                    -
                    <span class="blue--text">{{ (100 - ratioVerde(totali)).toFixed(1) }} %</span>
                  </td>
                  <td v-if="show_confronta">
                    <template v-if="!loading && totali_confronto">
                      <span class="green--text">{{ ratioVerde(totali_confronto).toFixed(1) }} %</span>
                      -
                      <span class="blue--text">{{ (100 - ratioVerde(totali_confronto)).toFixed(1) }} %</span>
                    </template>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta">
                    <span v-if="!loading && totali_confronto" :class="ratioVerde(totali) >= ratioVerde(totali_confronto) ? 'green--text' : 'red--text'">
                      {{ (ratioVerde(totali) - ratioVerde(totali_confronto)).toFixed(1) }} %
                    </span>
                    <span v-else class="grey--text">—</span>
                  </td>
                  <td v-if="show_confronta"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col cols="6">
          <VueApexCharts
            :options="options_bar"
            :series="records_pie"
            height="250"
          />
        </v-col>

        <!-- <v-col cols="2">
          <VueApexCharts
            v-if="show_confronta"
            width="250"
            type="donut"
            :options="options_pie_compare"
            :series="records_pie_confronto"
          />
        </v-col> -->
      </v-row>
      <!-- <v-row>
        {{ records }}
      </v-row> -->
      <v-row>
        <v-col cols="12">
          <VueApexCharts height="480" :options="options" :series="records" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <VueApexCharts
            height="400"
            :options="options_cumulato"
            :series="records_cumulato"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    VueApexCharts,
  },
  data() {
    return {
      loading: false,
      show_confronta: false,
      usa_contabili:
        localStorage.getItem("statistiche_usa_contabili") === "true",
      anno_confronto: moment().subtract(1, "year").format("YYYY"),
      anni: [
        moment().subtract(1, "year").format("YYYY"),
        moment().subtract(2, "year").format("YYYY"),
        moment().subtract(3, "year").format("YYYY"),
        moment().subtract(4, "year").format("YYYY"),
        moment().subtract(5, "year").format("YYYY"),
      ],
      intervallo: {
        inizio: moment().startOf("year").format("X"),
        fine: moment().add(3, "weeks").format("X"),
      },
      analisi: "week",
      analisi_list: [
        { label: "Settimana", value: "week" },
        { label: "Mese", value: "month" },
      ],
    };
  },
  mounted() {
    this.fetchAll();
  },
  watch: {
    intervallo() { this.fetchAll(); },
    analisi() { this.fetchAll(); },
    show_confronta() {
      if (this.show_confronta) this.fetchAll();
    },
    anno_confronto() {
      if (this.show_confronta) this.fetchAll();
    },
    usa_contabili() {
      localStorage.setItem("statistiche_usa_contabili", this.usa_contabili);
      this.fetchAll();
    },
  },
  computed: {
    options() {
      return {
        chart: {
          type: "line",
          zoom: { enabled: false, type: "x" },
          toolbar: { show: false },
        },
        forecastDataPoints: {
          count: this.forecastCount,
        },
        stroke: { curve: "smooth", width: 2 },
        grid: { show: true },
        legend: { show: true },
        yaxis: {
          show: true,
          labels: {
            formatter: (val) => {
              return (val / 1000).toFixed(0) + " K €";
            },
          },
        },
        xaxis: {
          labels: { show: true },
        },
        tooltip: {
          x: {
            show: true,
            // formatter: (val) => {
            //   if (this.analisi == "day") {
            //     return moment.unix(val).format("DD MMMM");
            //   } else {
            //     return "WK " + moment.unix(val).format("WW");
            //   }
            // },
          },
          y: {
            formatter: (val) => val.toFixed(2) + " €",
          },
        },
      };
    },
    options_cumulato() {
      return {
        chart: {
          type: "line",
        },
        forecastDataPoints: {
          count: this.forecastCount,
        },
        stroke: {
          curve: "smooth",
          width: [2, 2, 2, 1],
          dashArray: [0, 0, 3, 3],
        },
        grid: {
          show: true,
        },
        legend: {
          show: true,
        },
        yaxis: {
          show: true,
          labels: {
            formatter: (val) => {
              return (val / 1000).toFixed(0) + " K €";
            },
          },
        },
        xaxis: {
          labels: {
            show: true,
          },
          axixBorder: {
            show: false,
          },
        },
        tooltip: {
          x: {
            show: true,
          },
          y: {
            formatter: (val) => {
              return val.toFixed(2) + " €";
            },
          },
        },
      };
    },
    options_bar() {
      return {
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "80%",
            distributed: false,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => {
            return val.toFixed(2) + " €";
          },
          offsetX: 0,
          style: {
            fontSize: "13px",
            fontWeight: 600,
          },
        },
        chart: {
          stacked: true,
          type: "bar",
          height: 250,
          sparkline: {
            enabled: false,
          },
        },
        grid: {
          show: false,
        },
        legend: {
          show: false,
        },
        yaxis: {
          show: false,
        },
        xaxis: {
          show: false,
          categories: [moment().year(), this.anno_confronto],
          axixBorder: {
            show: true,
          },
        },
        colors: ["#2196F3", "#90CAF9", "#4CAF50", "#81C784"],
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return val.toFixed(2) + " €";
            },
          },
          x: {
            formatter: (val) => {
              return val;
            },
          },
        },
      };
    },
    labelPeriodo() {
      const found = this.periodi_list.find(
        (p) => p.value.inizio === this.intervallo.inizio && p.value.fine === this.intervallo.fine
      );
      return found ? found.label : "Periodo selezionato";
    },
    forecastCount() {
      const oggi = moment(); // Considera ieri come base per il calcolo
      // const inizio = moment.unix(this.intervallo.inizio);
      const fine = moment.unix(this.intervallo.fine);

      if (this.analisi === "week") {
        // Trova la prima settimana futura rispetto a oggi
        let current = oggi.clone().startOf("isoWeek");
        let count = 0;
        while (current.isSameOrBefore(fine)) {
          if (current.isAfter(oggi, "week")) {
            count++;
          }
          current.add(1, "week");
        }
        return count;
      } else if (this.analisi === "day") {
        // Trova il primo giorno futuro rispetto a oggi
        let current = oggi.clone().startOf("day");
        let count = 0;
        while (current.isSameOrBefore(fine)) {
          if (current.isAfter(oggi, "day")) {
            count++;
          }
          current.add(1, "day");
        }
        return count;
      }
      return 0;
    },
    periodi_list() {
      const lista = [];
      // 0. "Anno fino ad oggi"
      const oggi = moment();
      const fineAnno = moment().endOf("year");
      const fineIntervallo = moment.min(oggi.clone().add(3, "weeks"), fineAnno);
      lista.push({
        label: "Fino ad Oggi",
        type: "year",
        value: {
          inizio: moment().startOf("year").format("X"),
          fine: fineIntervallo.format("X"),
        },
      });
      // 1. "Anno in corso"
      lista.push({
        label: "Ultimo Anno",
        type: "year",
        value: {
          inizio: moment().startOf("year").format("X"),
          fine: moment().endOf("year").format("X"),
        },
      });

      // 2. "Mese corrente"
      const mese_corrente = moment().month(); // 0-based
      const start_corrente = moment().startOf("month");
      const end_corrente = moment().endOf("month");
      lista.push({
        label: "Mese corrente",
        type: "month",
        value: {
          inizio: start_corrente.format("X"),
          fine: end_corrente.format("X"),
        },
      });

      // 3. Proiezione 30 giorni

      const start_proiezione = moment().subtract(20, "days").startOf("day");
      const end_proiezione = moment().add(10, "days").endOf("day");
      lista.push({
        label: "Proiezione 30 giorni",
        type: "day",
        value: {
          inizio: start_proiezione.format("X"),
          fine: end_proiezione.format("X"),
        },
      });

      // 4. Mesi precedenti (dal mese scorso a gennaio, ordine inverso)
      for (let m = mese_corrente - 1; m >= 0; m--) {
        const start = moment().startOf("year").month(m).startOf("month");
        const end = moment().startOf("year").month(m).endOf("month");
        lista.push({
          label: start.format("MMMM"),
          type: "month",
          value: {
            inizio: start.format("X"),
            fine: end.format("X"),
          },
        });
      }

      return lista;
    },

    records() {
      let blu = [];
      let verde = [];
      let tot = [];
      const rapporto = this.$store.getters.get_rapporto_verde;
      const buckets = rapporto && rapporto.buckets ? rapporto.buckets : null;
      if (!buckets) {
        return [];
      }
      blu = buckets.map((el) => {
        let imponibile_iva =
          (el.contabili_solo_iva_saldato + el.contabili_solo_iva_non_saldato) *
          10;
        return {
          x: el.label,
          y:
            el.contabili_blu_non_saldato +
            el.contabili_blu_saldato +
            el.contabili_solo_iva_saldato +
            el.contabili_solo_iva_non_saldato +
            (imponibile_iva ? imponibile_iva : 0),
        };
      });
      verde = buckets.map((el) => {
        let imponibile_iva =
          (el.contabili_solo_iva_saldato + el.contabili_solo_iva_non_saldato) *
          10;
        return {
          x: el.label,
          y:
            el.contabili_verde_non_saldato +
            el.contabili_verde_saldato -
            (imponibile_iva ? imponibile_iva : 0),
        };
      });
      tot = buckets.map((el) => {
        return {
          x: el.label,
          y:
            el.contabili_blu_non_saldato +
            el.contabili_blu_saldato +
            el.contabili_verde_non_saldato +
            el.contabili_verde_saldato +
            (el.contabili_solo_iva_saldato ? el.contabili_solo_iva_saldato : 0)  +
            (el.contabili_solo_iva_non_saldato ? el.contabili_solo_iva_non_saldato : 0),
        };
      });
      const series = [
        { name: "Blu", data: blu, type: "bar", color: "#448AFF" },
        { name: "Verde", data: verde, type: "bar", color: "#00E676" },
        { name: "Totale", data: tot, type: "line", color: "#FF9100" },
      ];
      if (this.show_confronta) {
        const rapportoConfronto = this.$store.getters.get_rapporto_verde_confronto;
        let buckets_confronto = rapportoConfronto && rapportoConfronto.buckets ? rapportoConfronto.buckets : null;
        if (!buckets_confronto) return series;

        if (buckets_confronto.length > buckets.length) {
          const diff = buckets_confronto.length - buckets.length;
          buckets_confronto = buckets_confronto.slice(diff);
        }
        let blu_confronto = buckets_confronto.map((el) => {
          return {
            x: el.label,
            y: el.contabili_blu_non_saldato + el.contabili_blu_saldato,
          };
        });
        let verde_confronto = buckets_confronto.map((el) => {
          return {
            x: el.label,
            y: el.contabili_verde_non_saldato + el.contabili_verde_saldato,
          };
        });
        let tot_confronto = buckets_confronto.map((el) => {
          return {
            x: el.label,
            y:
              el.contabili_blu_non_saldato +
              el.contabili_blu_saldato +
              el.contabili_verde_non_saldato +
              el.contabili_verde_saldato,
          };
        });
        series.push(
          {
            name: "Blu confronto",
            data: blu_confronto,
            type: "bar",
            color: "#3F51B5",
          },
          {
            name: "Verde confronto",
            data: verde_confronto,
            type: "bar",
            color: "#009688",
          },
          {
            name: "Totale confronto",
            data: tot_confronto,
            type: "line",
            color: "#9C27B0",
          }
        );
      }
      return series;
    },
    records_cumulato() {
      const rapporto = this.$store.getters.get_rapporto_verde;
      const buckets = rapporto && rapporto.buckets ? rapporto.buckets : null;
      if (!buckets) {
        return [];
      }
      let cumulato = 0;
      let recs = [];
      buckets.forEach((el) => {
        cumulato +=
          el.contabili_blu_non_saldato +
          el.contabili_blu_saldato +
          el.contabili_verde_non_saldato +
          el.contabili_verde_saldato +
          el.contabili_solo_iva_saldato +
          el.contabili_solo_iva_non_saldato;
        el.cumulato = cumulato;
        recs.push({ x: el.label, y: el.cumulato });
      });

      let serie = [
        {
          name: "anno corrente",
          data: recs,
          type: "line",
          color: "#FF9100",
        },
      ];
      if (this.show_confronta) {
        let buckets_confronto =
          this.$store.getters.get_rapporto_verde_confronto.buckets;
        if (!buckets_confronto) {
          return serie;
        }

        if (buckets_confronto.length > buckets.length) {
          const diff = buckets_confronto.length - buckets.length;
          buckets_confronto = buckets_confronto.slice(diff);
        }

        let recs_confronto = [];
        let cumulato_confronto = 0;
        buckets_confronto.forEach((el) => {
          cumulato_confronto +=
            el.contabili_blu_non_saldato +
            el.contabili_blu_saldato +
            el.contabili_verde_non_saldato +
            el.contabili_verde_saldato;
          el.cumulato = cumulato_confronto;
          recs_confronto.push({ x: el.label, y: el.cumulato });
        });
        serie.push({
          name: "anno confronto",
          data: recs_confronto,
          type: "line",
          color: "#9C27B0",
        });
      }
      return serie;
    },
    records_pie() {
      return [
        {
          name: "Blu Saldato",
          data: [
            this.totali.blu_saldato ? this.totali.blu_saldato : this.totali.blu,
            this.totali_confronto ? this.totali_confronto.blu : 0,
          ],
        },
        {
          name: "Blu Non Saldato",
          data: [this.totali.blu_non_saldato ? this.totali.blu_non_saldato : 0, 0],
        },
        {
          name: "Verde Saldato",
          data: [
            this.totali.verde_saldato ? this.totali.verde_saldato : this.totali.verde,
            this.totali_confronto ? this.totali_confronto.verde : 0,
          ],
        },
        {
          name: "Verde Non Saldato",
          data: [this.totali.verde_non_saldato ? this.totali.verde_non_saldato : 0, 0],
        },
      ];
    },
    totali() {
      let summary = this.$store.getters.get_rapporto_verde_tabella.summary;
      if (!summary) {
        return {
          verde: 0,
          blu: 0,
          combinato: 0,
          rapporto: 0,
        };
      }
      let valore_iva = 0
      if (summary.total_solo_iva_saldato || summary.total_solo_iva_non_saldato) {
        valore_iva =
          summary.total_solo_iva_saldato + summary.total_solo_iva_non_saldato;
      }
      let valore_inponibile_iva = valore_iva * 10;
      return {
        verde:
          summary.total_verde_saldato +
          summary.total_verde_non_saldato -
          (valore_iva ? valore_inponibile_iva : 0),
        blu:
          summary.total_blu_saldato +
          summary.total_blu_non_saldato +
          (valore_iva ? valore_inponibile_iva + valore_iva : 0),
        blu_saldato:
          summary.total_blu_saldato +
          (summary.total_solo_iva_saldato * 10 +
            summary.total_solo_iva_saldato),
        verde_saldato:
          summary.total_verde_saldato - summary.total_solo_iva_saldato * 10,
        verde_non_saldato:
          summary.total_verde_non_saldato -
          summary.total_solo_iva_non_saldato * 10,
        blu_non_saldato:
          summary.total_blu_non_saldato +
          (summary.total_solo_iva_non_saldato * 10 +
            summary.total_solo_iva_non_saldato),
        combinato:
          summary.total_blu_saldato +
          (summary.total_blu_non_saldato ? summary.total_blu_non_saldato : 0) +
          summary.total_verde_saldato +
          (summary.total_verde_non_saldato ? summary.total_verde_non_saldato : 0) +
          valore_iva,
        rapporto:
          ((summary.total_blu_saldato + summary.total_blu_non_saldato) * 100) /
          (summary.total_verde_saldato +
            summary.total_verde_non_saldato +
            summary.total_blu_saldato +
            summary.total_blu_non_saldato),
      };
    },
    totali_confronto() {
      let summary = this.$store.getters.get_rapporto_verde_tabella_confronto.summary;
      if (!summary) {
        return null;
      }
      return {
        verde: summary.total_verde_saldato + summary.total_verde_non_saldato,
        blu: summary.total_blu_saldato + summary.total_blu_non_saldato,
        verde_non_saldato: summary.total_verde_non_saldato,
        blu_non_saldato: summary.total_blu_non_saldato,
        combinato:
          summary.total_blu_saldato +
          summary.total_blu_non_saldato +
          summary.total_verde_saldato +
          summary.total_verde_non_saldato,
        rapporto:
          ((summary.total_blu_saldato + summary.total_blu_non_saldato) * 100) /
          (summary.total_verde_saldato +
            summary.total_verde_non_saldato +
            summary.total_blu_saldato +
            summary.total_blu_non_saldato),
      };
    },
  },
  methods: {
    fetchAll() {
      this.loading = true;
      const fetches = [this._fetchPrincipale(), this._fetchTabellaCorrente()];
      if (this.show_confronta) {
        fetches.push(this._fetchConfronto());
        fetches.push(this._fetchConfrontoFineAnno());
        fetches.push(this._fetchTabellaConfronto());
      }
      Promise.all(fetches).finally(() => {
        this.loading = false;
      });
    },
    _fetchPrincipale() {
      const action = this.usa_contabili
        ? "fetch_rapporto_verde_contabile"
        : "fetch_rapporto_verde";
      return this.$store.dispatch(action, {
        ts_inizio: this.intervallo.inizio,
        ts_fine: this.intervallo.fine,
        risoluzione: this.analisi,
      });
    },
    _fetchConfronto() {
      const ts_inizio = moment.unix(this.intervallo.inizio).year(this.anno_confronto).format("X");
      const ts_fine = moment.unix(this.intervallo.fine).year(this.anno_confronto).format("X");
      const action = this.usa_contabili
        ? "fetch_rapporto_verde_confronto_contabile"
        : "fetch_rapporto_verde_confronto";
      return this.$store.dispatch(action, { ts_inizio, ts_fine, risoluzione: this.analisi });
    },
    _fetchTabellaCorrente() {
      const action = this.usa_contabili
        ? "fetch_rapporto_verde_tabella_contabile"
        : "fetch_rapporto_verde_tabella";
      return this.$store.dispatch(action, {
        ts_inizio: this.intervallo.inizio,
        ts_fine: moment().format("X"),
        risoluzione: this.analisi,
      });
    },
    _fetchTabellaConfronto() {
      const ts_inizio = moment.unix(this.intervallo.inizio).year(this.anno_confronto).format("X");
      const ts_fine = moment().year(this.anno_confronto).format("X");
      const action = this.usa_contabili
        ? "fetch_rapporto_verde_tabella_confronto_contabile"
        : "fetch_rapporto_verde_tabella_confronto";
      return this.$store.dispatch(action, { ts_inizio, ts_fine, risoluzione: this.analisi });
    },
    _fetchConfrontoFineAnno() {
      const ts_inizio = moment().year(this.anno_confronto).startOf("year").format("X");
      const ts_fine = moment().year(this.anno_confronto).endOf("year").format("X");
      const action = this.usa_contabili
        ? "fetch_rapporto_verde_confronto_fine_anno_contabili"
        : "fetch_rapporto_verde_confronto_fine_anno";
      return this.$store.dispatch(action, { ts_inizio, ts_fine, risoluzione: this.analisi });
    },
    formatEur(val) {
      return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(val || 0) + " €";
    },
    varClass(corrente, confronto) {
      if (!confronto) return "grey--text";
      return (corrente * 100) / confronto - 100 >= 0 ? "green--text" : "red--text";
    },
    varPct(corrente, confronto) {
      if (!confronto) return "N/D";
      return ((corrente * 100) / confronto - 100).toFixed(1) + " %";
    },
    varDelta(corrente, confronto) {
      if (!confronto) return "N/D";
      const delta = corrente - confronto;
      const formatted = new Intl.NumberFormat('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.abs(delta));
      return (delta >= 0 ? "+" : "-") + formatted + " €";
    },
    pctNonSaldato(nonSaldato, totale) {
      if (!totale) return "0.0 %";
      return ((nonSaldato * 100) / totale).toFixed(1) + " %";
    },
    ratioVerde(t) {
      return (t.verde * 100) / t.combinato;
    },
  },
};
</script>